import { render, staticRenderFns } from "./scene-number-input.vue?vue&type=template&id=3aee1cbd&scoped=true"
import script from "./scene-number-input.vue?vue&type=script&lang=js"
export * from "./scene-number-input.vue?vue&type=script&lang=js"
import style0 from "./scene-number-input.vue?vue&type=style&index=0&id=3aee1cbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aee1cbd",
  null
  
)

export default component.exports